module.exports = __webpack_public_path__ + "media/images/it/icons/x-479dacabf8fc85bb16fedfb383afc1b4.svg";